import { z } from 'zod';
import { SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';
import { CandidateEngagementsConst } from '@axiom/const';

import { OpportunitySchema } from './opportunity';
import { PositionSchema } from './position';
import { ZodCandidateOpportunityCandidateStatuses } from './candidate-opportunities-candidate-statuses';

const badges = Object.values(CandidateEngagementsConst.Badges);

export const CandidateEngagementSchema = z.object({
  id: z.string().uuid(),
  badges: z.array(z.enum(ZodArrayToEnum(badges))),
  candidateStatus: ZodCandidateOpportunityCandidateStatuses,
  candidateStatusUpdatedAt: SchemaTimestamp,
  opportunity: OpportunitySchema.pick({
    id: true,
    jobName: true,
  }),
  position: PositionSchema.pick({
    id: true,
    startDate: true,
  }),
});

export type CandidateEngagement = z.infer<typeof CandidateEngagementSchema>;

export const CandidateEngagementDetailsSchema = z.object({});

export type CandidateEngagementDetails = z.infer<
  typeof CandidateEngagementDetailsSchema
>;

export const ZodCandidateEngagementBadges = z.enum(ZodArrayToEnum(badges));
